import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../../../config/queryKeys'
import { getGameScoreboard } from '../../../services/game/timelineServices'

const SCOREBOARD_STALE_TIME = 2 * 60 * 1000 // 2 minutes
interface UseGameScoreboardOptions {
  gameId?: string | null
  isLive?: boolean
}

const useGameScoreboard = ({
  gameId,
  isLive = false,
}: UseGameScoreboardOptions) => {
  return useQuery({
    queryKey: queryKeys.gameScoreboard.byGame(gameId),
    queryFn: () => getGameScoreboard(gameId!),
    enabled: Boolean(gameId),
    staleTime: isLive ? 0 : SCOREBOARD_STALE_TIME, // 2 minutes
    refetchInterval: isLive ? 20000 : false,
  })
}

export default useGameScoreboard
